import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border-radius: 10px;
`;

export const Sufix = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.2rem;
`;
